import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess as SEOSegmentationSearchResults } from '@/__generated__/seoSegmentationListingPage';

// Define the state shape
export interface SearchState {
  filters: SEOSegmentationSearchResults['filters'];
  pagination: SEOSegmentationSearchResults['pagination'];
  caregiverSearchResults: SEOSegmentationSearchResults['caregiverSearchResults'];
  providerSearchResults: SEOSegmentationSearchResults['providerSearchResults'];
  jobSearchResults: SEOSegmentationSearchResults['jobSearchResults'];
  archivedJobSearchResults: SEOSegmentationSearchResults['archivedJobSearchResults'];
  pageNumber: number;
}

// Define all possible actions
export type SearchAction =
  | { type: 'SET_FILTERS'; payload: SEOSegmentationSearchResults['filters'] }
  | { type: 'SET_PAGE_NUMBER'; payload: number }
  | {
      type: 'UPDATE_ALL_RESULTS';
      payload: {
        filters?: SEOSegmentationSearchResults['filters'];
        pagination: SEOSegmentationSearchResults['pagination'];
        caregiverSearchResults: SEOSegmentationSearchResults['caregiverSearchResults'];
        providerSearchResults: SEOSegmentationSearchResults['providerSearchResults'];
        jobSearchResults: SEOSegmentationSearchResults['jobSearchResults'];
        archivedJobSearchResults: SEOSegmentationSearchResults['archivedJobSearchResults'];
      };
    };

// Create the reducer function
export const searchReducer = (state: SearchState, action: SearchAction): SearchState => {
  switch (action.type) {
    case 'SET_FILTERS':
      return { ...state, filters: action.payload };
    case 'SET_PAGE_NUMBER':
      return { ...state, pageNumber: action.payload };
    case 'UPDATE_ALL_RESULTS':
      return {
        ...state,
        filters: action.payload.filters ?? state.filters,
        pagination: action.payload.pagination,
        caregiverSearchResults:
          action.payload.caregiverSearchResults ?? state.caregiverSearchResults,
        providerSearchResults: action.payload.providerSearchResults ?? state.providerSearchResults,
        jobSearchResults: action.payload.jobSearchResults ?? state.jobSearchResults,
        archivedJobSearchResults:
          action.payload.archivedJobSearchResults ?? state.archivedJobSearchResults,
      };
    default:
      return state;
  }
};
